
            const data = {"name":"arrow-pointing-right","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"m8 16-1.41-1.41L12.17 9H0V7h12.17L6.59 1.41 8 0l8 8-8 8Z\" _fill=\"#343434\"/>","originalColors":[{"type":"fill","color":"#343434"}],"stopColors":[]}}
        
                    module.exports = data
                    